import { css } from "../__compat__/styled-components/main.entry.mjs.mjs";
const getStateColor = (props, color = 'default') => {
    if (props.disabled)
        return props.theme.colors.interaction.secondary.disabled;
    if (props.invalid)
        return props.theme.colors.ui.error;
    return props.theme.colors.interaction.secondary[color];
};
export const interactionBarSelector = '::after';
export const injectInteractionBarHoverStyles = (props) => css `
  border-bottom-color: var(${getStateColor(props, 'hover')});
`;
export const injectInteractionBarActiveStyles = (props) => css `
  background-color: var(${getStateColor(props, 'focus')});
  border-bottom-color: var(${getStateColor(props, 'focus')});
`;
export const injectInteractionBar = (props) => css `
  &${interactionBarSelector} {
    display: block;
    box-sizing: border-box;
    width: 100%;
    height: 2px;
    margin-top: -1px;

    border-bottom-color: var(${getStateColor(props)});
    border-bottom-width: 1px;
    border-bottom-style: solid;

    transition-timing-function: var(${props.theme.easing});
    transition-duration: 0.25s;
    transition-property: border-bottom-color, background-color;

    content: '';
  }

  ${!(props.disabled || props.static) &&
    css `
    &:focus-within${interactionBarSelector} {
      ${injectInteractionBarActiveStyles(props)}
    }

    &:hover&${interactionBarSelector}, *:hover ~ &${interactionBarSelector} {
      ${injectInteractionBarHoverStyles(props)}
    }
  `}
`;
//# sourceMappingURL=injectInteractionBar.mjs.mjs.map